import { useState, FunctionComponent, ChangeEvent } from 'react';
import classnames from 'classnames';

// Styles
import styles from './InputGroup.module.scss';

interface Props {
    id?: string;
    className?: string;
    inputProps?: {
        [key: string]: any;
        placeholder?: string;
        onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    };
    inputClassName?: string;
    placeholderClassName?: string;
}

const InputGroup: FunctionComponent<Props> = ({ inputProps: { placeholder, onChange, value, ...inputProps }, ...props }) => {
    const [isEmpty, setIsEmpty] = useState<boolean>(true);
    const [isFocus, setIsFocus] = useState<boolean>(false);

    const placeholderClassName = classnames([
        styles.placeholder,
        props.placeholderClassName,
        {
            [styles.focus]: !isEmpty || isFocus,
            focus: !isEmpty || isFocus,
        },
    ]);

    const handleChange = (event) => {
        if (event.target.value && isEmpty) {
            setIsEmpty(false);
        }

        if (!event.target.value && !isEmpty) {
            setIsEmpty(true);
        }

        if (onChange) onChange(event);
    };

    const handleToggleFocus = () => setIsFocus(!isFocus);

    return (
        <div className={classnames([styles.input_group, props.className])}>
            <input
                type="text"
                id={props.id}
                value={value}
                {...inputProps}
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleToggleFocus}
                onFocus={handleToggleFocus}
                className={classnames([styles.input, props.inputClassName])}
            />
            {placeholder && (
                <label htmlFor={props.id} className={placeholderClassName}>
                    {placeholder}
                </label>
            )}
        </div>
    );
};

InputGroup.defaultProps = {
    id: null,
    className: '',
    inputClassName: '',
    placeholderClassName: '',
    inputProps: {
        onChange: null,
    },
};

export default InputGroup;
